import deepmerge from 'deepmerge';

import type { ThemeColors } from '../../../../tokens/colors/types';
import type { BaseDeprecatedColors } from '../../../types';
import derivedED from './ED';

export default (baseColors: ThemeColors): BaseDeprecatedColors => {
  return {
    ...deepmerge(derivedED(baseColors), {
      promotional: {
        primary: {
          default: baseColors.primary['90'],
          dark: '#000000',
        },
        secondary: {
          default: baseColors.primary['50'],
          dark: '#6A3A1B',
        },
      },
    }),
  };
};
